module.exports = __webpack_public_path__ + "img/1.6a46a79e.png";